<template>
  <div
    class="card shadow table-container vld-parent"
    ref="calls_table"
    :class="type === 'dark' ? 'bg-default' : ''"
  >
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <router-link :to="{ name: 'admin_chamadas_new' }">
            <base-button type="primary" size="sm" :custom="true"
              >Criar nova chamada</base-button
            >
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template slot="columns">
          <th>Nome da chamada</th>
          <th>Categoria</th>
          <th>Região</th>
          <th>Data ínicio</th>
          <th>Data fim</th>
          <th>Inscrições</th>
          <th>Status da chamada</th>
          <th>Ações</th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row">
            <div class="media align-items-center">
              <i
                :class="[
                  row.type == 'Aceleração'
                    ? aceleracaoClass
                    : preAceleracaoClass,
                ]"
                class="ni ni-tag mr-3"
              >
              </i>
              <div class="media-body">
                <span class="name mb-0 text-sm">
                  <router-link
                    :to="`/admin/chamadas/${row.id}/editar`"
                    class="btn btn-link pl-0"
                  >
                    {{ row.name }}
                  </router-link>
                </span>
              </div>
            </div>
          </th>
          <td>
            {{ row.type }}
          </td>
          <td>
            {{ row.region || "-" }}
          </td>
          <td>
            {{ row.start_date }}
          </td>
          <td>
            {{ row.end_date }}
          </td>
          <td>
            <span class="bg-white border rounded py-2 px-3"
              >{{ row.subscriptions_count }}
              <i class="ni ni-spaceship ml-1 text-danger"></i
            ></span>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{ row.completion }}%</span>
              <div>
                <base-progress
                  :type="row.statusInfo.type"
                  :show-percentage="false"
                  class="pt-0"
                  :value="row.completion"
                />
              </div>
              <span class="ml-2" :title="row.statusInfo.description">{{
                row.statusInfo.name
              }}</span>
            </div>
            <div v-if="row.remaining && row.completion > 0">
              <span>Chamada encerra em {{ row.remaining }} dias</span>
            </div>
            <div v-else-if="row.missing">
              <span>Chamada inicia em {{ row.missing }} dias</span>
            </div>
          </td>
          <td>
            <router-link
              :to="'/admin/chamadas/' + row.id + '/editar'"
              class="btn btn-white py-1 px-2"
              title="Editar chamada"
              ><i class="fas fa-edit text-info"></i
            ></router-link>
            <router-link
              :to="'/admin/chamadas/' + row.id + '/inscricoes'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar inscrições"
              ><i class="fas fa-rocket text-warning"></i
            ></router-link>
            <router-link
              :to="'/admin/chamadas/' + row.id + '/avaliacao'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar avaliação"
              ><i class="fas fa-globe text-primary"></i
            ></router-link>
            <router-link
              :to="'/admin/chamadas/' + row.id + '/pitch-day'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar pitch day"
              ><i class="fas fa-marker text-warning"></i
            ></router-link>
            <router-link
              :to="'/admin/chamadas/' + row.id + '/due-diligence'"
              class="btn btn-white py-1 px-2"
              title="Gerenciar due diligence"
              ><i class="fas fa-search-dollar text-dark-green"></i
            ></router-link>
          </td>
        </template>
      </base-table>
      <p v-if="empty" class="text-center text-warning mt-3">
        Nenhuma chamada cadastrada até o momento
      </p>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "chamadas-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      tableData: [],
      empty: false,
      aceleracaoClass: "text-red",
      preAceleracaoClass: "text-blue",
      callStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Uma chamada regular fica visível para os investidores cadastrados no fundo.",
        },
        {
          key: "closed",
          value: "Encerrada",
          description:
            "O status 'Encerrada' ficará visível para os investidores cadastrados no fundo.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma chamada invisível fica oculta para todos os investidores.",
        },
      ],
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.calls_table,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get("/adm/startup-calls");
      data.forEach((startupCall) => {
        const { remaining, total, missing } = this.getDiffInfo(
          startupCall.start_date,
          startupCall.end_date
        );
        startupCall["remaining"] = remaining;
        startupCall["missing"] = missing;
        startupCall["completion"] = this.getCompletion(remaining, total);
        startupCall["start_date"] = this.formatDate(startupCall.start_date);
        startupCall["end_date"] = this.formatDate(startupCall.end_date);
        startupCall["value"] = this.formatValue(startupCall.value);
        startupCall["statusInfo"] = this.getStatusInfo(
          startupCall.status,
          startupCall.completion
        );
      });
      if (data.length) {
        this.tableData = data;
        this.$emit("calculatedStats", this.getStats());
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as chamadas");
    }
  },
  methods: {
    getCompletion(remainingDays, totalDays) {
      if (remainingDays == 0) return 100;
      if (remainingDays > totalDays) return 0;
      if (totalDays > 0 && remainingDays > 0)
        return Math.round(Math.abs((1 - remainingDays / totalDays) * 100));
      return 0;
    },
    getDiffInfo(start, end) {
      const d1 = this.moment(start);
      const d2 = this.moment(end);
      const today = this.moment();
      let totalDays = d2.diff(d1, "days");
      let remainingDays = today.startOf("day").isAfter(d2, "day")
        ? 0
        : d2.diff(today, "days");
      let missingDays = d1.isAfter(today, "day") ? d1.diff(today, "days") : 0;
      return {
        remaining: remainingDays,
        total: totalDays,
        missing: missingDays,
      };
    },
    getStatusInfo(currentStatus, completion) {
      const selectedStatus = this.callStatus.find(
        (status) => status.key === currentStatus
      );

      let statusInfo = {
        type: "info",
        name: selectedStatus.value,
        description: selectedStatus.description,
      };
      if (completion === 100) statusInfo.type = "success";
      else if (selectedStatus.key === "closed") statusInfo.type = "warning";
      if (selectedStatus.key === "hidden") statusInfo.type = "danger";
      return statusInfo;
    },
    getStats() {
      const stats = {};
      this.tableData.forEach((startupCall) => {
        const type = startupCall.type;
        if (!stats[type])
          stats[type] = {
            totalCalls: 0,
            regularCalls: 0,
            subscriptionsAvg: 0,
          };
        stats[type].totalCalls++;
        if (startupCall.status === "open") stats[type].regularCalls++;
        stats[type].subscriptionsAvg += startupCall.subscriptions_count;
      });
      if (stats["Aceleração"] && stats["Aceleração"].totalCalls > 0) {
        stats["Aceleração"].subscriptionsAvg = Math.round(
          stats["Aceleração"].subscriptionsAvg / stats["Aceleração"].totalCalls
        );
      }
      if (stats["Pré-aceleração"] && stats["Pré-aceleração"].totalCalls > 0) {
        stats["Pré-aceleração"].subscriptionsAvg = Math.round(
          stats["Pré-aceleração"].subscriptionsAvg /
            stats["Pré-aceleração"].totalCalls
        );
      }

      return stats;
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
